import { render, staticRenderFns } from "./GroupUpload.vue?vue&type=template&id=2cff5690&"
import script from "./GroupUpload.vue?vue&type=script&lang=js&"
export * from "./GroupUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports